/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RecalculateSymbolDto
 */
export interface RecalculateSymbolDto {
    /**
     * 
     * @type {string}
     * @memberof RecalculateSymbolDto
     */
    symbolId: string;
    /**
     * 
     * @type {Date}
     * @memberof RecalculateSymbolDto
     */
    minDate: Date;
}

export function RecalculateSymbolDtoFromJSON(json: any): RecalculateSymbolDto {
    return RecalculateSymbolDtoFromJSONTyped(json, false);
}

export function RecalculateSymbolDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecalculateSymbolDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'symbolId': json['symbolId'],
        'minDate': (new Date(json['minDate'])),
    };
}

export function RecalculateSymbolDtoToJSON(value?: RecalculateSymbolDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'symbolId': value.symbolId,
        'minDate': (value.minDate.toISOString()),
    };
}

